<script lang="ts">
	import { readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Helpers
	import { onSettingsResponse } from '../../../../../helpers/device_settings_helpers';

	//Services
	import { format } from '../../../../../services/i18n';
	import { postReq } from '../../../../../services/http';

	//Stores

	//Types
	import type { Device } from '../../../../../types/Device';
	import type { SettingRequest } from '../../../../../types/requests/settings/setting';

	//Design system components
	import { Button, Input } from '@Shelly/shelly-design-system';
	import { getContext, onDestroy } from 'svelte';
	import type { Writable } from 'svelte/store';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import type { SidepanelStickyBottomProps } from 'src/components/Sidepanel/sidepanel-types';
	export let device: Device;

	const min = 0,
		max = 10;

	const settings = readDeviceSettings(device.id);
	let value = settings?.[device.category + 's'][0]?.valve_min_percent;
	let loading = false,
		cacheValue = value;

	const sendRequest = async (): Promise<void> => {
		if (cacheValue !== value) {
			cacheValue = value;
			let res: SettingRequest = await postReq(
				`/device/generic_command`,
				{
					id: device.id,
					command: `valve`,
					payload: JSON.stringify({
						valve_min_percent: +value,
						id: device.channel,
					}),
				},
				20000,
			);
			onSettingsResponse(res, device);
			loading = false;
		}
	};

	const stickyBottomAction =
		getContext<Writable<SidepanelStickyBottomProps | null>>('stickyBottomAction');

	$: if (stickyBottomAction) {
		if ($showNewLayout) {
			stickyBottomAction.set({ onClick: sendRequest, loading, disabled: loading });
		} else {
			stickyBottomAction.set(null);
		}
	}

	onDestroy(() => {
		stickyBottomAction?.set(null);
	});
</script>

<Input
	bind:value
	size="m"
	type={'number'}
	{min}
	{max}
	info={$format('min_valve_description', {
		values: { min, max },
		default: `Set minimum position of valve (${min}% - ${max}%)`,
	})}
	on:enter={sendRequest}
	id="input-mcscf4l"
	aria-label={$format('min_valve_description', {
		values: { min, max },
		default: `Set minimum position of valve (${min}% - ${max}%)`,
	})}
/>
{#if !$showNewLayout}
	<Button {loading} class="mt-s" size="m" width="full" on:click={sendRequest}>
		{$format('button_save')}
	</Button>
{/if}
